export class AddressModel {
  address1?: string;
  address2?: string;
  unit?: string;
  streetNumber?: string;
  city?: string;
  country?: string;
  province?: string;
  provinceCode?: string;
  postalCode?: string;
  postalCodeExt?: string;
  addressLine?: string;


  /**
   * @returns true if all the required address fields are at least 1 character in length, and if postal code is 7 characters long, since thats the canadian postal code length, counting the space else returns false
   */
  static validateAddressModel(addressModel: AddressModel): boolean {
    if(
         addressModel.address1 != undefined
      && addressModel.streetNumber != undefined
      && addressModel.city != undefined
      && addressModel.postalCode != undefined
      && addressModel.province != undefined
      && addressModel.country != undefined
  
      && addressModel.address1.length > 0
      && addressModel.streetNumber.length > 0
      && addressModel.city.length > 0
      && addressModel.postalCode.length == 7
      && addressModel.province.length > 0
      && addressModel.country.length > 0
    ){
      return true;
    }
    return false;
  }
}